<template>
  <aha-dropdown class="top-4">
    <aha-dropdown-items
      v-if="currentUser.rememberSettings"
      @hide="$emit('togglePresentOptions')"
      :visible="showPresentOptions"
      class="z-20 rounded-lg shadow present-dropdown-v2 p-1"
      right
    >
      <aha-dropdown-item
        class="px-4 py-4 h-full border-base-30 border-b"
        @click="$emit('handlePresentMenuClick', 'present-now')"
        v-if="!isNewPresentation"
      >
        <div class="flex justify-between items-center">
          <p class="font-bold text-secondary-100 flex gap-4 items-center">
            <aha-icon
              name="aha-presentation-chart"
              class="text-transparent"
              viewBox="0 0 16 16"
            />
            <span>{{ $i18nPresenter.t('Present from the current slide') }}</span>
          </p>
          <span class="text-gray-70 tracking-wider">Shift P</span>
        </div>
      </aha-dropdown-item>
      <aha-dropdown-item
        class="px-4 py-4 h-full border-base-30 border-b"
        @click="$emit('handlePresentMenuClick', 'present-from-beginning')"
        v-if="!isNewPresentation"
      >
        <div class="flex gap-4 items-center">
          <aha-icon
            name="aha-presentation-chart-first"
            class="text-transparent"
            viewBox="0 0 16 16"
          />
          <p class="font-bold text-secondary-100">
            {{ $i18nPresenter.t('Present from the first slide') }}
          </p>
        </div>
      </aha-dropdown-item>
      <aha-dropdown-item
        name="open-backstage"
        v-aha-emit-action="{
          source: 'PresentButton',
          stage_type: 'backstage'
        }"
        class="px-4 py-4 h-full border-base-30 border-b"
        @click="$emit('handlePresentMenuClick', 'present-with-backstage')"
        v-if="!isNewPresentation"
      >
        <div class="flex items-center justify-between">
          <div class="flex gap-4 items-center">
            <aha-icon
              name="aha-backstage"
              class="text-transparent"
              viewBox="0 0 16 16"
            />
            <div>
              <p class="flex items-center mb-1 font-bold text-secondary-100">
                {{ $i18nPresenter.t('Present with Backstage') }}
              </p>
              <p class="text-xs whitespace-normal">
                {{ $i18nPresenter.t('Preview slides, notes & Q&A') }}
              </p>
            </div>
          </div>
          <span class="text-xs text-coral-65 bg-coral-25 rounded-lg px-2 py-1 font-bold">
            Beta
          </span>
        </div>
      </aha-dropdown-item>
      <aha-input-group
        class="flex items-center px-4 py-4 rounded-b-lg"
      >
        <aha-checkbox
          v-model="currentUser.rememberSettings.fullscreen"
          @change="toggleFullscreenSetting"
          id="full-screen-check"
        >
          {{ $i18nPresenter.t('Full screen') }}
        </aha-checkbox>
      </aha-input-group>
    </aha-dropdown-items>
  </aha-dropdown>
</template>

<script>
import { mapState } from 'vuex'
import utils from '@/util'
import eventCategories from '@/constant/eventCategories'
import UserApi from '@/api/user'

export default {
  props: {
    showPresentOptions: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      isNewPresentation: (state) => state.isNewPresentation,
      presentation: (state) => state.presentation,
      currentUser: (state) => state.currentUser,
    }),
  },
  methods: {
    // AHA-890 Remember fullscreen setting
    toggleFullscreenSetting(e) {
      this.$nextTick(async () => {
        const payload = {
          fullscreen: e,
        }
        await UserApi.updateSettings(payload)

        if (e) {
          utils.mixpanelTracking(
            eventCategories.PRESENTATION_EDITOR,
            'Extra Present Button > Fullscreen checkbox > Checked fullscreen mode',
          )
        } else {
          utils.mixpanelTracking(
            eventCategories.PRESENTATION_EDITOR,
            'Extra Present Button > Fullscreen checkbox > Unchecked fullscreen mode',
          )
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";

.present-now__wrapper {
  @apply h-auto pt-4 pb-3 border-b rounded-t-lg border-base-30 px-4;
}
.backstage__badge {
  @apply bg-yellow-50 ml-1;
}

.present-dropdown-v2 {
  min-width: $right-panel-width;
}
</style>
